import { Box, CardBody, CardFooter, CardHeader, FormControl, FormErrorMessage, FormLabel, Input, Skeleton, VStack } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { SubmitBtn } from "../../atoms/button/SubmitBtn";
import { DarkShadowCard } from "../../molecules/card/DarkShadowCard";
import { CardHeading } from "../../molecules/card/CardHeading";
import { SettingsIcon } from "@chakra-ui/icons";
import { useFetchBenchmarkRestaurant } from "../../../hooks/ifreaAnalytics/useFetchBenchmarkRestaurant";
import { useEditBenchmarkRestaurantForm } from "../../../hooks/ifreaAnalytics/useEditBenchmarkRestaurantForm";
import { useEditBenchmarkRestaurant } from "../../../hooks/ifreaAnalytics/useEditBenchmarkRestaurant";


export const EditBenchmarkRestaurant = () => {
  const { benchmarkRestaurantId } = useParams();
  const { benchmarkRestaurant, isLoading } = useFetchBenchmarkRestaurant(benchmarkRestaurantId);
  const { handleSubmit, register, isSubmitting, errors } = useEditBenchmarkRestaurantForm(benchmarkRestaurant)
  const onSubmit = useEditBenchmarkRestaurant(benchmarkRestaurantId)
  const nameError = errors.name?.message;
  const urlError = errors.url?.message;
  return (
    <Box m='auto' w={{base: '100%', md: '600px'}}>
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <DarkShadowCard>
          <CardHeader>
            <CardHeading icon={<SettingsIcon />} heading='ID紐づけ'/>
          </CardHeader>
          <CardBody py={2}>
            <VStack spacing={5}>
              <FormControl isRequired isInvalid={!!errors.name} w='100%'>
                <FormLabel>店舗名</FormLabel>
                <Skeleton isLoaded={!isLoading} w='100%' borderRadius={5}>
                  <Input type="text" {...register('name')} />
                </Skeleton>
                <FormErrorMessage>{nameError}</FormErrorMessage>
              </FormControl>
              <FormControl isRequired isInvalid={!!errors.url} w='100%'>
                <FormLabel>URL</FormLabel>
                <Skeleton isLoaded={!isLoading} w='100%' borderRadius={5}>
                  <Input type="text" {...register('url')} />
                </Skeleton>
                <FormErrorMessage>{urlError}</FormErrorMessage>
              </FormControl>
            </VStack>
          </CardBody>
          <CardFooter>
            <SubmitBtn isLoading={isSubmitting}>登録</SubmitBtn>
          </CardFooter>
        </DarkShadowCard>
      </form>
    </Box>
  );
};